export const lineHeight = 19.2;

export const getTextWidth = text => {
  const context = document.createElement('canvas').getContext('2d');
  context.font = '600 16px Source Sans Pro';
  const { width } = context.measureText(text);

  return width;
};

export const splitTextToLines = (text = '') => {
  const words = text.split(/\s+/g).filter(Boolean);
  const targetLineWidth = Math.sqrt(getTextWidth(text.trim()) * lineHeight);

  const lines = [];
  let currentLineText = '';
  let currentLineWidth = 0;

  words.forEach(word => {
    const newLineText = (currentLineText ? currentLineText + ' ' : '') + word;
    const newLineWidth = getTextWidth(newLineText);
    const wordFitsInCurrentLine =
      !currentLineText || (currentLineWidth + newLineWidth) / 2 < targetLineWidth;

    if (wordFitsInCurrentLine) {
      currentLineText = newLineText;
      currentLineWidth = newLineWidth;
    } else {
      lines.push({ width: currentLineWidth, text: currentLineText });
      currentLineText = word;
      currentLineWidth = getTextWidth(word);
    }
  });

  lines.push({ width: currentLineWidth, text: currentLineText });

  return lines;
};

export const getTextRadius = (text = '') => {
  const lines = splitTextToLines(text);
  const lineRadiuses = lines.map((line, index) => {
    const offset = Math.abs(index - lines.length / 2 + 0.5) + 0.5;
    const dy = offset * lineHeight;
    const dx = line.width / 2;

    return Math.sqrt(dx ** 2 + dy ** 2);
  });

  return Math.max(0, ...lineRadiuses);
};

export const getElementSize = elementId => {
  const { width, height } = document.getElementById(elementId).getBoundingClientRect();

  return { width, height };
};
